import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router';
import { toast } from 'react-toastify';
import Notification from '../../SharedComponents/Notification';
import { AddComplaintStatus } from './ApiComplaints';

export default function ApproveComplaint(props) {
  const { t } = useTranslation();
  const { submitId } = useParams();
  const queryClient = useQueryClient();
  const AddComplaintStatusMutation = useMutation(AddComplaintStatus, {
    onSuccess: () => {
      queryClient.refetchQueries('getComplaintBySubmitId');

      toast(<Notification message={t('Complaint Approved')} />);
    },
  });
  const onClick = () => {
    console.log('clicked');
    AddComplaintStatusMutation.mutate({
      complaintStatus: 1,
      submitId: submitId,
    });
  };
  return (
    <button
      onClick={onClick}
      type="button"
      className="bg-green-500 hover:bg-green-700 text-white px-4 py-2 text-sm rounded-md"
    >
      {t('Approve')}
    </button>
  );
}
